export default {
    label: {
        archivedAt: '保存日時',
        client: '取引先',
        deliveryMethods: '送付手段',
        document: '書類',
        documentExternalId: '書類外部ID',
        legalDeliveryCategories: '法的発行形態',
        sender: '送信者',
        total: '取引金額',
        transactionDate: '発行日（取引日）',
    },
    title: '書類控え詳細',
    viewPdf: 'PDFを見る',
};
